import React from 'react';
import {
  Totaliser as ToolkitTotaliser,
  Snowglobe,
} from '@justgiving/totaliser';
import { isMobileUserAgent } from 'src/helpers/browser';

interface Props {
  percentage: number;
  requestedSize?: 'small' | 'medium' | 'medium-large' | 'large';
}

const Totaliser: React.StatelessComponent<Props> = ({
  percentage,
  requestedSize,
}) => {
  const size = requestedSize
    ? requestedSize
    : isMobileUserAgent()
      ? 'medium'
      : 'large';

  const date = new Date();
  const month = date.getMonth();
  const day = date.getDate();
  const isXmas = month === 11 && day >= 15;

  return (
    <div className="jg-center-block">
      <ToolkitTotaliser percent={percentage} size={size} isAnimated>
        {isXmas ? <Snowglobe /> : null}
      </ToolkitTotaliser>
    </div>
  );
};

export default Totaliser;



// WEBPACK FOOTER //
// ./src/components/Totaliser/Totaliser.tsx